import React, { CSSProperties } from 'react';
import clsx from 'clsx';

import { Badge as StyledBadge, Text, Tail, ReadMore } from './wrappers';
import { useTrackGenericEvent } from '../../hooks/tracking/useTrackingEvents';
import useCompose from '../../hooks/useCompose';

const clickEvent = { event: 'product_flag_click' };

interface IBadge {
  buttonText?: string;
  className?: string;
  label: string;
  borderRadius?: boolean;
  large?: boolean;
  onClick?: () => void;
  productCard?: boolean;
  cart?: boolean;
  fitToContent?: boolean;
  defaultColorScheme?: boolean;
  style?: CSSProperties;
  tail?: string;
  tone?: 'sale' | 'highlight' | string;
  collapsed?: boolean | 'mobile' | 'desktop';
  renderLink?: () => JSX.Element;
}

const Badge = ({
  buttonText = 'Läs mer',
  className,
  collapsed,
  label,
  large,
  onClick,
  productCard,
  fitToContent,
  defaultColorScheme,
  renderLink,
  style,
  tail,
  tone,
  cart,
  borderRadius = true,
}: IBadge) => {
  const trackClick = useTrackGenericEvent(clickEvent);
  const clickHandler = useCompose(trackClick, onClick);
  return (
    <StyledBadge
      className={clsx(
        className,
        large && 'large',
        productCard && 'product-card',
        fitToContent && 'fit-to-content',
        defaultColorScheme && 'default-color-scheme',
        tone === 'highlight' && 'tone-highlight',
        collapsed === true && `collapsed`,
        cart && 'cart',
        collapsed && collapsed !== true && `collapsed-${collapsed}`,
        borderRadius && 'border-radius',
      )}
      style={style}>
      <Text>
        {label}
        {tail && <Tail>{tail}</Tail>}
      </Text>
      {onClick && <ReadMore onClick={clickHandler}>{buttonText}</ReadMore>}
      {renderLink && renderLink()}
    </StyledBadge>
  );
};

export default Badge;
